<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="cancelService()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-searchbar placeholder="Search Jobs" debounce="300" [(ngModel)]="queryText"></ion-searchbar>
    </ion-toolbar>
</ion-header>

<ion-content>
    <!--    <ion-refresher slot="fixed" (ionRefresh)="refreshDocs($event)">-->
    <!--        <ion-refresher-content-->
    <!--                pullingIcon="arrow-dropdown"-->
    <!--                pullingText="Pull to refresh"-->
    <!--                refreshingSpinner="circles"-->
    <!--                refreshingText="Fetching Documents...">-->
    <!--        </ion-refresher-content>-->
    <!--    </ion-refresher>-->
    <div padding>
        <ion-label>
            <h2>Serviced Item</h2>
            <h4 *ngIf="document.serviceJob.servicedItem.pdesc"
                style="color: #1aacc3">{{document.serviceJob.servicedItem.pdesc}}
                -{{document.serviceJob.servicedItem.reg}}</h4>
            <h4 *ngIf="document.serviceJob.servicedItem.serial" style="color: #1aacc3">Serial
                - {{document.serviceJob.servicedItem.serial}}</h4>
            <h4 style="color: #1aacc3">{{document.serviceJob.servicedItem.description}}</h4>
        </ion-label>
    </div>
    <ion-card *ngFor="let doc of documentJobList | filterDocs: queryText; let display = false;"
              (click)="openJobHistory(doc.serviceJob)">
        <ion-card-content>
            <ion-grid>
                <ion-row>
                    <ion-row>
                        <ion-label>
                            <h3>{{doc.serviceJob.jobNumber}} - {{doc.serviceJob.scheduledDate | date:'dd/MM/yyyy'}}
                                - {{doc.serviceJob.engineer ? doc.serviceJob.engineer.name : ''}}</h3>
                            <h3>{{doc.serviceJob.jobType}}</h3>
                            <h4 *ngIf="doc.serviceJob.cust" style="color: #1aacc3">{{doc.serviceJob.cust.name}}</h4>
                            <p>{{doc.serviceJob.noteText}}</p>
                        </ion-label>
                    </ion-row>
                    <!--            <ion-row *ngIf="!display">-->
                    <!--                <ion-label (click)="display = ! display">Tap to display more details...</ion-label>-->
                    <!--            </ion-row>-->
                    <ion-row *ngIf="display && doc.serviceJob.tasks.length > 0">
                        <ion-col size="12" no-padding>
                            <ion-list no-padding>
                                <ion-list-header>
                                    <ion-label>Tasks</ion-label>
                                </ion-list-header>
                                <ion-item *ngFor="let task of doc.serviceJob.tasks">
                                    <ion-label><p>{{task.description}}</p></ion-label>
                                    <ion-icon slot="end" [name]="tasksIcons.getIcon(task.option)"
                                              [color]="tasksIcons.getColor(task.option)"></ion-icon>
                                </ion-item>
                            </ion-list>
                        </ion-col>
                    </ion-row>
                    <ion-row *ngIf="display && doc.serviceJob.spares.length > 0" align-self-stretch>
                        <ion-col>
                            <ion-list no-padding>
                                <ion-list-header>
                                    <ion-label>Spares</ion-label>
                                </ion-list-header>
                                <ion-item *ngFor="let spare of doc.serviceJob.spares">
                                    <ion-label>{{spare.description}}</ion-label>
                                    <ion-icon slot="end" name="cart"></ion-icon>
                                </ion-item>
                            </ion-list>
                        </ion-col>
                    </ion-row>
                    <ion-row *ngIf="display && doc.serviceJob.meterReadings.length > 0" align-self-stretch>
                        <ion-col>
                            <ion-list no-padding>
                                <ion-list-header>
                                    <ion-label>Meter Readings</ion-label>
                                </ion-list-header>
                                <ion-item *ngFor="let reading of doc.serviceJob.meterReadings" lines="none">
                                    <ion-label>{{reading.description}}: {{reading.value}}</ion-label>
                                </ion-item>
                            </ion-list>
                        </ion-col>
                    </ion-row>
                </ion-row>
            </ion-grid>
        </ion-card-content>
    </ion-card>
</ion-content>
